import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import BomsTab from "./Tabs/bom";
import SubBomsTab from "./Tabs/subbom";
import ParentBomsService from "../../../../services/parentboms.service";
import ChildBomsService from "../../../../services/childboms.service";
import SubBomsService from "../../../../services/subboms.service";
import handleChangeWebsiteTab from "../../../../commons/ChangeWebsiteTab";
import { filteredItemInArray } from "../../../../utils/ManageArray";

export default function BOMInformation() {
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ Parent: [], Child: [], SubBom: [] });
  const tabNames = { Bom: "ข้อมูล BOM", SubBom: "ข้อมูล SUB BOM" };
  const columns = {
    Child: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px",
        conditionalCellStyles: [
          { when: (row) => row, classNames: ["selectedSingle"] }
        ]
      },
      {
        name: "รหัสอะไหล่/อุปกรณ์",
        selector: (row) => row.Item.Item_Code,
        sortable: true,
        grow: 1.5
      },
      {
        name: "ชื่ออะไหล่",
        selector: (row) => row.Item.Item_Name_TH,
        grow: 2.5
      },
      { name: "Model Number", selector: (row) => row.Item.Item_Model },
      { name: "จำนวน", selector: (row) => row.Item_Child_Qty, center: true },
      { name: "หน่วยนับ", selector: (row) => row.Item.Unit, center: true },
      {
        name: "เช็ค/เปลี่ยน",
        selector: (row) => (row.Bom_Pm ? "Y" : "N"),
        center: true
      },
      {
        name: "SUB BOM",
        selector: (row) => (row.SubBom ? "Y" : "N"),
        center: true
      }
    ],
    SubBom: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รหัสลูกค้า",
        selector: (row) => row.Customer.Cus_Code,
        sortable: true,
        grow: 1.5
      },
      { name: "ชื่อลูกค้า", selector: (row) => row.Customer.Cus_Name, grow: 2 },
      {
        name: "รหัสอะไหล่/อุปกรณ์",
        selector: (row) => row.Item.Item_Code,
        sortable: true,
        grow: 1.5
      },
      { name: "ชื่ออะไหล่", selector: (row) => row.Item.Item_Name_TH, grow: 2 },
      {
        name: "Model Number",
        selector: (row) => row.Item.Item_Model,
        grow: 1.5
      },
      {
        name: "จำนวน",
        selector: (row) => row.Item_Child_Sub_Qty,
        center: true
      },
      { name: "หน่วยนับ", selector: (row) => row.Item.Unit, center: true }
    ]
  };

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ParentBomsService.getAllParentBoms(),
      callback: (res) => setData((prev) => ({ ...prev, Parent: res }))
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ChildBomsService.getAllChildBoms(),
      callback: (res) => setData((prev) => ({ ...prev, Child: res }))
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: SubBomsService.getAllSubBoms(),
      callback: (res) =>
        setData((prev) => ({
          ...prev,
          SubBom: filteredItemInArray(res, "ChildBom.Sub_Bom", true)
        }))
    });
    handleChangeWebsiteTab({ key: state || "Bom", tabNames, setWebsiteName });
  }, []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="BOM Information Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={state || "Bom"}
          onSelect={(key) =>
            handleChangeWebsiteTab({ key, tabNames, setWebsiteName })
          }
        >
          <Tab eventKey="Bom" title="ข้อมูล BOM">
            {websiteName === "ข้อมูล BOM" && (
              <BomsTab data={data} columns={columns} loading={loading} />
            )}
          </Tab>

          <Tab eventKey="SubBom" title="ข้อมูล SUB BOM">
            {websiteName === "ข้อมูล SUB BOM" && (
              <SubBomsTab data={data} columns={columns} loading={loading} />
            )}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
